<template>
    <div class="wrapper-form-block-nomeempresarial" :inert="pPreview">
        <p><strong>Indique abaixo 3 sugestões de nomes para a empresa.</strong></p>
      <br/>
      <div :class="{'allow-markup-error': markupErrorNomeEmpresarial1}">
        <TrfInput
          class="mb-3"
          label="Nome empresarial (Sugestão 1)"
          placeholder="Primeiro nome sugerido"
          margin="0"
          id="form-block-nomeempresarial1"
          v-model="nomeEmpresarial1"
          maxLength="50"
          ref="BlockNomeEmpresarial1"
          v-e2e="'form-block-nomeEmpresarial1'"
          :required="false"
        ></TrfInput>
        <p class="error-message mb-4" v-if="markupErrorNomeEmpresarial1">
          Campo obrigatório!
        </p>
      </div>
      <div :class="{'allow-markup-error': markupErrorNomeEmpresarial2}">
        <TrfInput
          class="mb-3"
          label="Nome empresarial (Sugestão 2)"
          placeholder="Segundo nome sugerido"
          margin="0"
          id="form-block-nomeempresarial2"
          v-model="nomeEmpresarial2"
          maxLength="50"
          ref="BlockNomeEmpresarial2"
          :required="false"
          v-e2e="'form-block-nomeEmpresarial2'"
        ></TrfInput>
        <p class="error-message mb-4" v-if="markupErrorNomeEmpresarial2">
          Campo obrigatório!
        </p>
      </div>
      <div :class="{'allow-markup-error': markupErrorNomeEmpresarial3}">
        <TrfInput
          label="Nome empresarial (Sugestão 3)"
          placeholder="Terceiro nome sugerido"
          margin="0"
          id="form-block-nomeempresarial3"
          v-model="nomeEmpresarial3"
          maxLength="50"
          ref="BlockNomeEmpresarial3"
          :required="false"
          v-e2e="'form-block-nomeEmpresarial3'"
        ></TrfInput>
        <p class="error-message" v-if="markupErrorNomeEmpresarial3">
          Campo obrigatório!
        </p>
      </div>
    </div>
  </template>
  <script>
  import { defineAsyncComponent } from 'vue';
  export default {
    name: 'TrfBlocoNomeEmpresarial',
    emits: ['update:form-data', 'set:validacao'],
    components: {
        TrfInput: defineAsyncComponent(() => import('../../Input/index.vue'))
    },
    props: {
        pNomeEmpresarial1: {
            type: String,
            default: ""
        },
        pNomeEmpresarial2: {
            type: String,
            default: ""
        },
        pNomeEmpresarial3: {
            type: String,
            default: ""
        },
        pPreview: {
            type: Boolean,
            default: true
        },
        pEmpresa: {
          type: Object,
          default: () => {}
        },
        pIsDirty: {
          type: Boolean,
          default: false
        },
        required: {
          type: Boolean,
          default: false
        }
    },
    data() {
      return {
        nomeEmpresarial1: this.pEmpresa?.nomeEmpresarial1? `${this.pEmpresa.nomeEmpresarial1}` : this.pNomeEmpresarial1,
        nomeEmpresarial2: this.pEmpresa?.nomeEmpresarial2? `${this.pEmpresa.nomeEmpresarial2}` : this.pNomeEmpresarial2,
        nomeEmpresarial3: this.pEmpresa?.nomeEmpresarial3? `${this.pEmpresa.nomeEmpresarial3}` : this.pNomeEmpresarial3,
        formData: {
            nomeEmpresarial: [
                this.pEmpresa?.nomeEmpresarial1? `${this.pEmpresa.nomeEmpresarial1}` : this.pNomeEmpresarial1,
                this.pEmpresa?.nomeEmpresarial2? `${this.pEmpresa.nomeEmpresarial2}` : this.pNomeEmpresarial2,
                this.pEmpresa?.nomeEmpresarial3? `${this.pEmpresa.nomeEmpresarial3}` : this.pNomeEmpresarial3
            ]
        },
        dirtyState: {
          nomeEmpresarial1: this.pIsDirty,
          nomeEmpresarial2: this.pIsDirty,
          nomeEmpresarial3: this.pIsDirty
        }
      };
    },
    watch: {
        nomeEmpresarial1: {
            immediate: true,
            handler() {
                this.setNomeEmpresarial()
                this.emitFormData(this.getFormData())
                this.dirtyState.nomeEmpresarial1 = true
            }
        },
        nomeEmpresarial2: {
            immediate: true,
            handler() {
                this.setNomeEmpresarial()
                this.emitFormData(this.getFormData())
                this.dirtyState.nomeEmpresarial2 = true
            }
        },
        nomeEmpresarial3: {
            immediate: true,
            handler() {
                this.setNomeEmpresarial()
                this.emitFormData(this.getFormData())
                this.dirtyState.nomeEmpresarial3 = true
            }
        },
        pIsDirty: {
            immediate: true,
            handler(novo) {
                this.isDirty = novo
            }
        },
        isInvalida: {
            immediate: true,
            handler(novo) {
                if(this.required) {
                    this.$emit('set:validacao', !novo);
                }
            }
        }
    },
    computed: {
      isInvalida() {
        return this.isNomeEmpresarial1Invalido || this.isNomeEmpresarial2Invalido || this.isNomeEmpresarial3Invalido
      },
      isDirty: {
        get() {
          return this.dirtyState.nomeEmpresarial1 && this.dirtyState.nomeEmpresarial2 && this.dirtyState.nomeEmpresarial3;
        },
        set(valor) {
          for(let campo in this.dirtyState) {
            this.dirtyState[campo] = valor
          }
        }
      },
      isNomeEmpresarial1Invalido() {
        if (!this.required) return false;
        return this.dirtyState.nomeEmpresarial1 && !this.nomeEmpresarial1?.trim()
      },
      isNomeEmpresarial2Invalido() {
        if (!this.required) return false;
        return this.dirtyState.nomeEmpresarial2 && !this.nomeEmpresarial2?.trim()
      },
      isNomeEmpresarial3Invalido() {
        if (!this.required) return false;
        return this.dirtyState.nomeEmpresarial3 && !this.nomeEmpresarial3?.trim()
      },
      markupErrorNomeEmpresarial1() {
        return !this.pPreview && this.isNomeEmpresarial1Invalido
      },
      markupErrorNomeEmpresarial2() {
        return !this.pPreview && this.isNomeEmpresarial2Invalido
      },
      markupErrorNomeEmpresarial3() {
        return !this.pPreview && this.isNomeEmpresarial3Invalido
      },
    },
    methods: {
        setNomeEmpresarial() {
            this.formData.nomeEmpresarial = [
                this.nomeEmpresarial1,
                this.nomeEmpresarial2,
                this.nomeEmpresarial3
            ]
        },
        getFormData() {
            return this.formData
        },
        emitFormData(formData = this.formData) {
            this.$emit('update:form-data', {
                nomeEmpresarial1: this.nomeEmpresarial1,
                nomeEmpresarial2: this.nomeEmpresarial2,
                nomeEmpresarial3: this.nomeEmpresarial3
            })
        }
    }
  };
  </script>
  